/*
 * Copyright (c) 2021. Lukas Tschaftary
 *
 * NOTICE:  All information contained herein is, and remains the property of Lukas Tschaftary and his suppliers, if any.
 * The intellectual and technical concepts contained herein are proprietary to Lukas Tschaftary and its suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from Lukas Tschaftary.
 */

import React, {Component} from 'react';
import {Transition} from "react-transition-group";
import PropTypes from "prop-types";

const transitonStyle = {
    entering: " translate-x-0",
    entered: " translate-x-5",
    exiting: " translate-x-0",
    exited: " translate-x-0",
};

class Switch extends Component {
    render() {
        return (
            <div className="flex items-center">
                <button type="button" onClick={() => {
                    if (this.props.onChange !== undefined) {
                        this.props.onChange()
                    }
                }}
                        className={"bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-md cursor-pointer transition-colors ease-in-out duration-100 focus:outline-none  " + (this.props.value ? "bg-blue-300" : "bg-gray-200")}
                        role="switch" aria-checked="false">
                    <Transition in={this.props.value} timeout={20}>
                        {state => (<span aria-hidden="true"
                                         className={"translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-md bg-white shadow transform ring-0 flex items-center  absolute transition ease-in-out duration-100 " + transitonStyle[state]}>  </span>)}
                    </Transition>
                </button>
                <span className="ml-3 truncate">
                        <span
                            className="text-sm font-medium text-gray-900 ">{this.props.text}</span>
                 </span>
            </div>
        );
    }
}

Switch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool,
    text: PropTypes.string
};

export default Switch;